"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderJourneyResults = exports.castAsJourney = void 0;
var orderPlainResults_1 = require("./orderPlainResults");
function castAsJourney(item, journeyProperty) {
    if (!(journeyProperty in item))
        return null;
    var validItem = item;
    var propertyValues = validItem[journeyProperty];
    return propertyValues;
}
exports.castAsJourney = castAsJourney;
function removePropertyFromPath(appliedOrderValue, journeyProperty) {
    var path = appliedOrderValue.path
        .split(".")
        .filter(function (property) { return property !== journeyProperty; })
        .join(".");
    return __assign(__assign({}, appliedOrderValue), { path: path });
}
function updatePropertyFromPath(appliedOrderValue, journeyProperty, newPath) {
    var pathList = appliedOrderValue.path.split(".");
    pathList.shift();
    pathList.unshift(newPath);
    pathList.unshift(journeyProperty);
    var updatedPath = pathList.join(".");
    return __assign(__assign({}, appliedOrderValue), { path: updatedPath });
}
function orderJourneyResults(results, appliedOrderValue, journeyProperty) {
    var orderJourneys = results.map(function (journeyList) {
        var _a;
        var validJourneyList = castAsJourney(journeyList, journeyProperty);
        if (!validJourneyList)
            return journeyList;
        var filteredJourneys = validJourneyList.map(function (journey) {
            return (0, orderPlainResults_1.orderPlainResults)(journey, removePropertyFromPath(appliedOrderValue, journeyProperty));
        });
        return __assign(__assign({}, journeyList), (_a = {}, _a[journeyProperty] = filteredJourneys, _a));
    });
    var firstJourneyOptionIndex = "0.0";
    return (0, orderPlainResults_1.orderPlainResults)(orderJourneys, updatePropertyFromPath(appliedOrderValue, journeyProperty, firstJourneyOptionIndex));
}
exports.orderJourneyResults = orderJourneyResults;
//# sourceMappingURL=orderJourneyResults.js.map